import React from 'react'
import Eula from '../eula'

const EulaEn = () => {
    return <Eula languageCode="en" />
}

export default EulaEn
